import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { BannerDetails } from "../../banners.types";
import { ApiRoutesBanners } from "../../constants";

export const requestGetBanner = async (
  bannerId?: string
): Promise<BannerDetails> => {
  return await instance.get(buildUrl(ApiRoutesBanners.Banners, bannerId ?? ""));
};
